export const environment = {
  production: true,
  recaptcha: {

    //sandbox
    // siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

    //Prod
    siteKey: '6LedotstAAAAABvltRIQ0fhC-syVkPqpnu8C1fWv'
  },


   // baseUrl: 'https://goodrxprivacysettlement-web-staging.azurewebsites.net/api/'
  baseUrl: 'https://www.goodrxprivacysettlement.com/api/'
  // baseUrl: 'https://localhost:7249/api/'
};

